import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getMatchingTeachers(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/matching/teachers`, {
        params,
        headers,
    });
    return data;
}

export async function getMatchingStudents(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/matching/students`, {
        params,
        headers,
    });
    return data;
}

export async function createAdminMatch(payload) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.post(`${host}/matching`, payload, {
        headers,
    });
    return data;
}

// Applies a whole recommended plan in one request. Deliberately not N calls to
// createAdminMatch: the backend's duplicate guard only holds when the inserts
// are serialized.
export async function createAdminMatches(items) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.post(`${host}/matching/batch`, { items }, {
        headers,
    });
    return data;
}
